(function () {
	angular.module('dcApp').filter('entityType', function () {
		return function (value) {
			return (value =
				value != undefined && value === 'ENTITETYPE' ? 'Entité métier' : null);
		};
	});
})();
